import Cookies from "js-cookie";

const COOKIE = "whoxa_email_required";

export function setEmailRequiredGate(required: boolean) {
  if (required) {
    Cookies.set(COOKIE, "1", { expires: 30 });
  } else {
    Cookies.remove(COOKIE);
  }
}

export function isEmailRequiredGate(): boolean {
  return Cookies.get(COOKIE) === "1";
}

export function userNeedsEmail(user?: { email?: string | null } | null): boolean {
  return !String(user?.email || "").trim();
}

/** Paths allowed while email gate is active */
export function isEmailGateAllowedPath(pathname: string): boolean {
  const p = pathname.split("?")[0];
  return (
    p === "/bind-email" ||
    p === "/login" ||
    p === "/otp-verification" ||
    p === "/privacy-policy"
  );
}
